/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Fixture from '../model/Fixture';

/**
* Fixture service.
* @module api/FixtureApi
* @version 1.0.0
*/
export default class FixtureApi {

    /**
    * Constructs a new FixtureApi. 
    * @alias module:api/FixtureApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Get initial fixture data
     * Get initial data to fill combos
     * @param {String} locale student language
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Fixture} and HTTP response
     */
    getFixtureWithHttpInfo(locale) {
      let postBody = null;
      // verify the required parameter 'locale' is set
      if (locale === undefined || locale === null) {
        throw new Error("Missing the required parameter 'locale' when calling getFixture");
      }

      let pathParams = {
      };
      let queryParams = {
        'locale': locale
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Fixture;
      return this.apiClient.callApi(
        '/account/fixtures', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get initial fixture data
     * Get initial data to fill combos
     * @param {String} locale student language
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Fixture}
     */
    getFixture(locale) {
      return this.getFixtureWithHttpInfo(locale)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
